import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { writeNarrowedOrganizationId } from '@/lib/selected-organization';
import { invalidateWorkspaceContext } from '@/lib/auth/workspace-context';

/**
 * Narrows every list to one Standort (`null` = all): writes the narrow, drops the cached workspace context and
 * replace-navigates to the same path so the route's loaders re-run. Shared by the Standort switcher and the
 * dashboard's „choose a Standort" prompt, so the two cannot drift.
 */
export function useNarrowStandort(): (organizationId: string | null) => void {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (organizationId: string | null) => {
      writeNarrowedOrganizationId(organizationId);
      invalidateWorkspaceContext();
      navigate(location.pathname, { replace: true });
    },
    [navigate, location.pathname],
  );
}
